import React, { Component } from 'react';
import StartPage from '../PAGES/StartPage';
import GamePage from '../PAGES/GamePage';
import { START_PAGE, GAME_PAGE, SKILL_PAGE } from '../../HOME/const';
import { connect } from 'react-redux';
import SkillPage from '../PAGES/SkillPage';
import { updateStats } from '../REDUX/actions';
import { goToPage } from '../../HOME/REDUX/actions';

class MindShapes extends Component {
  componentDidMount() {
    if (!this.props.page) {
      this.props.goToPage(START_PAGE);
    }
  }

  render() {
    const page = this.props.page || START_PAGE;

    return (
      <>
        {page === START_PAGE ? <StartPage /> : null}
        {page === SKILL_PAGE ? <SkillPage /> : null}
        {page === START_PAGE ? <StartPage /> : null}
        {page === GAME_PAGE ? <GamePage /> : null}
      </>
    );
  }
}

function mapStateToProps({ ms, common }) {
  return { ...ms, ...common };
}

export default connect(
  mapStateToProps,
  { updateStats, goToPage }
)(MindShapes);
